// @flow
import React from "react"
import { connect } from "react-redux"
import bind from "memoize-bind"

import StarredTripsList from "common/components/StarredTripsList/StarredTripsList"
import { goToJourney as _goToJourney } from "common/services/starred/starredDuck"
import {
  starredPlacesSelector,
  starredSelector,
  starredItemBaseUrlGetterSelector,
} from "common/services/starred/starredSelectors"
import getPopupItems, { MAX_ITEMS } from "./services/getPopupItems"
import type { StarredStore, StarredItem, StarredPlaces } from "common/records/Starred.types"
import Translate from "../../../../components/Translate"
import Popup from "common/components/Popup/Popup"
import NavbarStarredItem from "./NavbarStarredItem"

type Props = {
  starredStore: StarredStore,
  starredPlaces: StarredPlaces,
  language: string,
  onClose: (SyntheticEvent<*>) => void,
  goToJourney: typeof _goToJourney,
  starredBaseUrlGetter: StarredItem => string,
  isMobile: boolean,
}

const NavbarStarredPopup = ({
  starredStore,
  starredPlaces,
  language,
  onClose,
  goToJourney,
  starredBaseUrlGetter,
  isMobile,
}: Props) => {
  const emptyStore = starredStore.items.length === 0

  return (
    <Popup className="NavbarStarred-popup" onHide={onClose} keepOnPopup scrollBlock={isMobile}>
      <StarredTripsList>
        {(actionButton, onToggleStar, onRemoveStar) => (
          <div className="NavbarStarred-items">
            <div className="NavbarStarred-header">
              <Translate
                className="NavbarStarred-header-item"
                tKey="starred.total_flights"
                values={{ total: starredStore.items.length }}
              />
              {actionButton}
            </div>
            <div className="NavbarStarred-list">
              {emptyStore ? (
                <div className="NavbarStarred-no-starred">
                  <Translate tKey="starred.no_flights" />
                </div>
              ) : (
                <div className="NavbarStarred-list-wrapper">
                  {getPopupItems(starredStore.items).map(item => (
                    <NavbarStarredItem
                      key={item.id}
                      item={item}
                      starredPlaces={starredPlaces}
                      onRemove={onRemoveStar}
                      onToggle={onToggleStar}
                      goToJourney={bind(
                        (_item: StarredItem, e: SyntheticEvent<*>) => {
                          goToJourney(_item)
                          onClose(e)
                        },
                        null,
                        item,
                      )}
                      shareUrl={starredBaseUrlGetter(item)}
                    />
                  ))}
                </div>
              )}
            </div>
            {!emptyStore && (
              <div className="NavbarStarred-footer">
                <a
                  className="spTypoLink"
                  rel="noopener noreferrer"
                  target="_blank"
                  href={`/${language}/content/account/starred`}
                >
                  {starredStore.items.length > MAX_ITEMS ? (
                    <Translate className="NavbarStarred-header-item" tKey="common.view_all" />
                  ) : (
                    <Translate className="NavbarStarred-header-item" tKey="starred.starred_trips" />
                  )}
                </a>
              </div>
            )}
          </div>
        )}
      </StarredTripsList>
    </Popup>
  )
}

// $FlowFixMe TODO: plz add type when updating
export default connect(
  state => ({
    starredStore: starredSelector(state),
    starredPlaces: starredPlacesSelector(state),
    starredBaseUrlGetter: starredItemBaseUrlGetterSelector(state),
    language: state.options.get("language"),
  }),
  { goToJourney: _goToJourney },
)(NavbarStarredPopup)
